import { render, staticRenderFns } from "./instagram.svg.vue?vue&type=template&id=07b05b8e&"
import script from "./instagram.svg.vue?vue&type=script&lang=js&"
export * from "./instagram.svg.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports